import React, { Component, Fragment } from 'react'
import { FormInput, FormPassword, FormSubmit } from '@myxplor/forms'
import HeadingRocket from '../heading-rocket'

class Impersonate extends Component {
  constructor(props) {
    super(props)

    this.state = {
      user: null,
      password: null,
      subject: null,
      loading: false,
      success: false,
      errors: {}
    }
  }

  getToken = (user, password) => {
    return fetch(`${process.env.REACT_APP_API_HOST}/api/v1/auth`,
      {
        method: 'POST',
        headers: new Headers({ 'content-type': 'application/json' }),
        body: JSON.stringify({ user: user, password: password, strategies: 'SuperAdmin' })
      }
    )
      .then(resp => {
        if (!resp.ok) return Promise.reject(resp)
        return resp.json()
      })
      .then(resp => {
        return resp.data.token
      })
  }

  handleChange = (name, value) => {
    this.setState({ [name]: value })
  }

  handleSubmit = (event) => {
    event.preventDefault()

    this.setState({ loading: true, errors: {}, success: false })
    this.getToken(this.state.user, this.state.password)
      .then(token => {
        return fetch(`${process.env.REACT_APP_API_HOST}/api/v1/impersonate`,
          {
            method: 'POST',
            headers: new Headers({
              'content-type': 'application/json',
              'authorization': `Bearer ${token}`
            }),
            credentials: 'include',
            body: JSON.stringify({ subject: this.state.subject })
          }
        )
      })
      .then(resp => {
        if (!resp.ok) return Promise.reject(resp)
        return resp.json()
      })
      .then(() => {
        this.setState({
          success: true,
          loading: false
        })
      })
      .catch(err => {
        let errors = {}

        if(err.status === 401) {
          errors = {
            user: ['Incorrect login details'],
            password: ['Incorrect login details']
          }
        }

        if(err.status === 500) {
          errors = {
            summary: ['Something went wrong, have you supplied a valid subject?']
          }
        }

        this.setState({
          loading: false,
          success: false,
          errors: errors
        })

      })
  }

  render() {
    if(this.state.success) {
      return (
        <Fragment>
          <HeadingRocket>Impersonation Successul!</HeadingRocket>

          <p>You have successfully impersonated: {this.state.subject}</p>
          <p>You now have a refresh cookie set!</p>
        </Fragment>
      )
    }

    return (
      <Fragment>
        <HeadingRocket>Impersonate a User</HeadingRocket>

        <p>Enter your SuperAdmin credentials and the user you would like to impersonate (for example &#39;Parent/12&#39;), and we&#39;ll get you logged in as that user.</p>

        <form onSubmit={this.handleSubmit}>
          <fieldset>
            <FormInput
              label='Username'
              name='user'
              required={true}
              errors={this.state.errors.user}
              loading={this.state.loading}
              onChange={this.handleChange}
            />
            <FormPassword
              label='Password'
              name='password'
              required={true}
              errors={this.state.errors.password}
              loading={this.state.loading}
              onChange={this.handleChange}
            />
          </fieldset>
          <fieldset>
            <FormInput
              label='Subject'
              name='subject'
              required={true}
              errors={this.state.errors.subject}
              loading={this.state.loading}
              onChange={this.handleChange}
            />
          </fieldset>

          <FormSubmit
            loading={this.state.loading}
            errors={this.state.errors.summary}
          >Impersonate User</FormSubmit>
        </form>
      </Fragment>
    )
  }
}

export default Impersonate



// WEBPACK FOOTER //
// ./src/impersonate/index.js